import {
    primaryColor,
    primaryBoxShadow,
    whiteColor,
    grayColor,
  } from "../../assets/jss/material-dashboard-pro-react.jsx";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

  const importedStyle = dashboardStyle; 

  const styles = {
    cardIconTitle: {
      ...importedStyle.cardTitle,
      marginTop: "15px",
      marginBottom: "0px",
    },
    labelHorizontal: {
        justifyContent: "center",
        fontSize: "15px"
    },
    updateInfo: {
      color: "red"
    },
    containerLine: {
      padding: "0.9375rem 0"
    },
    selectMenuItem: {
        fontSize: "13px",
        padding: "10px 20px",
        margin: "0 5px",
        borderRadius: "2px",
        transition: "all 150ms linear",
        display: "block",
        clear: "both",
        fontWeight: "400",
        lineHeight: "2",
        whiteSpace: "nowrap",
        color: grayColor[7],
        paddingRight: "30px",
        "&:hover": {
          backgroundColor: primaryColor[0],
          color: whiteColor,
          ...primaryBoxShadow
        }
      },
      selectMenuItemSelected: {
        backgroundColor: primaryColor[0] + "!important",
        color: whiteColor
      },
      select: {
        width: "100%"
      },
      txtField: {
        width: "100%"
      },
      btnClass: {
        paddingBottom: "0.9375rem"
      },
      deleteIconStyle: {
        "&:hover": {
          cursor: "pointer",
          color: "red"
        }
      },
      addIconStyle: {
        "&:hover": {
          cursor: "pointer",
          color: primaryColor[0],
        }
      }
  };

  export default styles;